import { Directive, HostBinding, Input } from '@angular/core';

function isAddClass(isReq: any = true): boolean {
  return isReq === '' || (isReq !== false && isReq !== 'false');
}

@Directive({
  selector: `jd-grid[jd-no-padding],[grid][jd-no-padding], jd-grid[jd-fixed],[grid[jd-fixed]`
})
export class JdGridExpDirective {
  private _noPadding = false;
  private _fixed = false;

  @HostBinding('class.fixed')
  @Input('jd-fixed')
  set fixed(value: boolean) {
    this._fixed = isAddClass(value);
  }

  get fixed() {
    return this._fixed;
  }

  @HostBinding('class.no-padding')
  @Input('jd-no-padding')
  set noPadding(value: boolean) {
    this._noPadding = isAddClass(value);
  }

  get noPadding() {
    return this._noPadding;
  }
  constructor() {}
}
